module.exports = __webpack_public_path__ + "static/img/vcode_6.7e92d474.jpg";